export enum PlatformsId {
  SMARTLINKS = "KP005",
}
